export function sendString(value: any) {

    return value || ''
}